/* Mitlaufender Kaufknopf am Handy (20.10.2026), Markup in sections/gg-kaufleiste.liquid.
   Die Leiste ist sichtbar, solange der echte Kaufknopf nicht im Bild ist: vorher (Knopf weiter unten) und nachher (weggescrollt).
   Tippen klickt den echten Knopf: gleiche Variante und Menge, gleicher Warenkorb-Hinweis, gleiche Messung. */
(function () {
  var leiste, beobachter, echt;
  function finde() { return document.querySelector('product-form button[name="add"]'); }
  function preisText() {
    var p = document.querySelector('[id^="price-template"] .price');
    if (!p) return '';
    var el = p.classList.contains('price--on-sale') ? p.querySelector('.price__sale .price-item--last') : p.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.trim() : '';
  }
  function abgleich() {
    var knopf = leiste.querySelector('[data-gg-kaufleiste-knopf]');
    var preis = leiste.querySelector('[data-gg-kaufleiste-preis]');
    var t = preisText();
    if (t && preis) preis.textContent = t;
    if (echt && knopf) {
      var span = echt.querySelector('span');
      knopf.disabled = echt.disabled;
      knopf.textContent = echt.disabled ? ((span ? span.textContent : echt.textContent).trim() || 'Ausverkauft') : 'In den Warenkorb';
    }
  }
  function beobachte() {
    echt = finde();
    if (!echt) return;
    if (beobachter) beobachter.disconnect();
    beobachter = new IntersectionObserver(function (eintraege) {
      var imBild = eintraege[eintraege.length - 1].isIntersecting;
      if (!imBild) abgleich();
      leiste.classList.toggle('is-sichtbar', !imBild);
    });
    beobachter.observe(echt);
  }
  function init() {
    leiste = document.querySelector('[data-gg-kaufleiste]');
    if (!leiste || leiste.hasAttribute('data-gg-bereit') || !('IntersectionObserver' in window)) return;
    leiste.setAttribute('data-gg-bereit', '');
    beobachte();
    abgleich();
    leiste.querySelector('[data-gg-kaufleiste-knopf]').addEventListener('click', function () {
      var b = finde();
      if (b && !b.disabled) b.click();
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { beobachte(); abgleich(); }, 50); });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
